import { Grid, Modal } from '@mui/material';
import { makeStyles } from '@mui/styles';
import * as React from 'react';

const useStyles = makeStyles((theme) => ({
    content: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        background: theme.palette.background.secondary,
        boxShadow: 24,
        padding: theme.spacing(2),
        borderRadius: theme.spacing(2),
    }
}));

export default function CustomModal(props) {
    const classes = useStyles();
    const { open, children, handleClose, maxWidth } = props;
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Grid item xs={12} className={classes.content} style={{ width: maxWidth ? maxWidth : 400}}>
                {children}
            </Grid>
        </Modal>
    );
}